import UserNotification from "util/UserNotification";
const executeDuplicationHandler = async (view, isPermitted, duplicationHandlers) => {
  let updatedView = view.toBuilder().build();
  for (const duplicationHandler of duplicationHandlers) {
    const viewWithPluginData = await duplicationHandler(updatedView, isPermitted).catch((e) => {
      const errorMessage = `An error occurred when executing a submit handler from a plugin: ${e}`;
      console.error(errorMessage);
      UserNotification.error(errorMessage);
      return updatedView;
    });
    if (viewWithPluginData) {
      updatedView = viewWithPluginData;
    }
  }
  return updatedView;
};
export const executePluggableSearchDuplicationHandler = (view, isPermitted, pluggableSaveViewControls) => {
  const pluginDuplicationHandlers = pluggableSaveViewControls == null ? void 0 : pluggableSaveViewControls.map(({ onSearchDuplication }) => onSearchDuplication).filter((pluginData) => !!pluginData);
  return executeDuplicationHandler(view, isPermitted, pluginDuplicationHandlers);
};
export const executePluggableDashboardDuplicationHandler = (view, isPermitted, pluggableSaveViewControls) => {
  const pluginDuplicationHandlers = pluggableSaveViewControls == null ? void 0 : pluggableSaveViewControls.map(({ onDashboardDuplication }) => onDashboardDuplication).filter((pluginData) => !!pluginData);
  return executeDuplicationHandler(view, isPermitted, pluginDuplicationHandlers);
};
